module.exports = __webpack_public_path__ + "static/img/s-cheng.c857585.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s-cheng.png
// module id = 35Pw
// module chunks = 1